import React from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import withModal from '../modal/withModal';

const propTypes = {
  actionProps: PropTypes.shape({
    title: PropTypes.string,
    QRCodeValue: PropTypes.any,
  }),
};

const QRCodeModal = ({ actionProps: { title, QRCodeValue } = {} }) => {
  if (!QRCodeValue) {
    return null;
  }

  return (
    <>
      <p>{title}</p>

      <div className="qr-code-modal-qr-code">
        <QRCode
          id="qr-code-modal-qr-code"
          value={QRCodeValue}
          renderAs="canvas"
          size={165}
        />
      </div>
    </>
  );
};

QRCodeModal.propTypes = propTypes;

export const QR_CODE_MODAL = 'modal/QR_CODE';

export default withModal(QRCodeModal, {
  name: QR_CODE_MODAL,
  size: 'sm',
  className: 'qr-code-modal',
});
